var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1Disabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 150,
    viewBox: "0 0 100 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2796",
    "data-name": "Group 2796",
    transform: "translate(-496 -610)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2138",
    "data-name": "Group 2138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1119",
    "data-name": "Rectangle 1119",
    transform: "translate(496 610)",
    fill: "#fff",
    stroke: "#cfcfcf",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 150,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 149,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1120",
    "data-name": "Rectangle 1120",
    transform: "translate(510 618)",
    fill: "#fff",
    stroke: "#cfcfcf",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 71,
    height: 71,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1128",
    "data-name": "Rectangle 1128",
    width: 72,
    height: 1,
    transform: "translate(510 695)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1131",
    "data-name": "Rectangle 1131",
    width: 72,
    height: 1,
    transform: "translate(510 707)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1129",
    "data-name": "Rectangle 1129",
    width: 72,
    height: 1,
    transform: "translate(510 701)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1130",
    "data-name": "Rectangle 1130",
    width: 72,
    height: 1,
    transform: "translate(510 713)",
    fill: "#cfcfcf"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_1",
    "data-name": 1,
    transform: "translate(537 745)",
    fill: "#cfcfcf",
    fontSize: 24,
    fontFamily: "HelveticaNeue, Helvetica Neue",
    letterSpacing: "0.2em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Disabled);
export default __webpack_public_path__ + "static/media/1-disabled.6f9d49ec.svg";
export { ForwardRef as ReactComponent };